// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head[data-v-5db65beb]{margin-bottom:10px}.clearfix[data-v-5db65beb]:after{content:\"\";height:0;line-height:0;display:block;visibility:hidden;clear:both}.send-back[data-v-5db65beb]{position:fixed;width:50%;left:50%;transform:translateX(-50%);bottom:30%;border:1px solid #000;background-color:#fff;padding:10px}.send-back-textarea[data-v-5db65beb]{width:100%;padding:10px}", ""]);
// Exports
module.exports = exports;
